const routes = [
  {
    index: true,
    label: 'Sako Tech',
    path: '/',
  },
  {
    label: 'About',
    path: '/about',
  },
  {
    label: 'Services',
    path: '/services',
  },
  // {
  //   label: 'Projects',
  //   path: '/projects',
  // },
  // {
  //   label: 'Stats',
  //   path: '/stats',
  // },
  {
    label: 'Contact',
    path: '/contact',
  },
  {
    label: 'Privacy Policy',
    path: '/privacypolicy.html',
  },
];

export default routes;
